import { Grid2 as Grid } from "@mui/material";
import { useDisabledInput } from "@sinch/hooks/utilities/UseDisabledInput";
import React from "react";
import { useTranslation } from "react-i18next";
import { NumberInput } from "@sinch/components";
import { CheckboxInput } from "@sinch/components/form/CheckboxInput/CheckboxInput";

export const MinimumHoursInput = ({ value, onChange }: { value: number; onChange: (val: number) => void }) => {
  const { t } = useTranslation();

  const [disabled, setDisabled] = useDisabledInput<number>({
    initDisabled: !value,
    initialValue: value,
    onChange: onChange,
    emptyValue: 0,
  });

  return (
    <Grid alignItems="center" container direction="row" spacing={1}>
      <Grid size="auto">
        <CheckboxInput
          checked={!disabled}
          data-cy="IntervalSelect-minimumHours-checkbox"
          FormControlProps={{ fullWidth: false }}
          infoTooltip={t("RateBuilder.minimumHoursDescription")}
          label={t("RateBuilder.minimumHours")}
          onChange={(e) => setDisabled(!e.target.checked)}
        />
      </Grid>
      <Grid size={1} sx={{ minWidth: "80px" }}>
        <NumberInput
          data-cy="IntervalSelect-minimumHours-input"
          disabled={disabled}
          fullWidth={false}
          min={0}
          onChange={onChange}
          step="any"
          value={value}
        />
      </Grid>
    </Grid>
  );
};
